import { ClientError } from './client-error';

export class AssessmentEngineLogicError extends ClientError {
  constructor(message: string) {
    super(message);

    this.name = 'AssessmentEngineLogicError';
  }
}
